import { ConfirmDialog } from '@koolumbus/web/ui';
import { createTxs } from '@koolumbus/web/utils';
import React from 'react';

interface AuctionBidActionsDialogsProps {
  isRejectOpen: boolean;
  isAcceptOpen: boolean;
  onCloseReject: () => void;
  onCloseAccept: () => void;
  onRejectConfirm: () => void;
  onAcceptConfirm: () => void;
}

const AuctionBidActionsDialogs: React.FC<
  React.PropsWithChildren<AuctionBidActionsDialogsProps>
> = ({
  isRejectOpen,
  isAcceptOpen,
  onCloseReject,
  onCloseAccept,
  onRejectConfirm,
  onAcceptConfirm,
}) => {
  const tx = useTxs();

  return (
    <>
      <ConfirmDialog
        variant="danger"
        isOpen={isRejectOpen}
        onClose={onCloseReject}
        title={tx.reject.title}
        body={tx.reject.body}
        onConfirm={onRejectConfirm}
      />
      <ConfirmDialog
        isOpen={isAcceptOpen}
        onClose={onCloseAccept}
        title={tx.accept.title}
        body={tx.accept.body}
        onConfirm={onAcceptConfirm}
      />{' '}
    </>
  );
};

const useTxs = createTxs({
  en: {
    accept: {
      title: 'Accept bid',
      body: "Do you really want to accept this bid?\n The auction will be closed and you won't receive any more offers.",
    },
    reject: {
      title: 'Reject bid',
      body: 'Do you really want to reject this offer?',
    },
  },
  it: {
    accept: {
      title: 'Accetta offerta',
      body: "Accettando quest'asta verrai messo in comunicazione con il proprietario, l'asta verrà chiusa e non riceverai più offerte. Vuoi procedere?",
    },
    reject: {
      title: 'Rifiuta offerta',
      body: "L'offerta scomparirà e non potrai più accettarla. Confermi di voler rifiutare questa offerta?",
    },
  },
});

export default AuctionBidActionsDialogs;
